/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TweenLite} from "gsap";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {HorribleHeroesReelController} from "../../reel/HorribleHeroesReelController";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelController} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {HorribleHeroes} from "../../HorribleHeroes";
import {HorribleHeroesParsedGameData} from "../../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesGameModuleConfig} from "../../HorribleHeroesGameModuleConfig";
import {HorribleHeroesReelSymbol} from "../../symbols/HorribleHeroesReelSymbol";
import {HorribleHeroesGameConfig} from "../../HorribleHeroesGameConfig";

export class ReelStop implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private readonly _reelId: number;
    private readonly _stopDelay: number;
    private readonly _quickStopDelay: number;
    private isAlreadyPlayed: boolean;

    /**
     * @constructs
     * @param reelId
     * @param stagger
     * @param abortStagger
     */
    constructor(reelId: number, stagger?: number, abortStagger?: number) {
        this._reelId = reelId;
        this._stopDelay = HorribleHeroes.timelineReelsController.getReelConfig(this._reelId).stopDelay;
        this._quickStopDelay = HorribleHeroes.timelineReelsController.getReelConfig(this._reelId).quickStopDelay;

        //Override config
        if (stagger !== undefined) {
            this._stopDelay = stagger;
        }
        if (abortStagger !== undefined) {
            this._quickStopDelay = abortStagger;
        }

        this.stagger = this._stopDelay;
        this.abortStagger = this._quickStopDelay;
    }

    /**
     * @inheritDoc
     * @param data
     */
    public getAnimation(data: HorribleHeroesParsedGameData): Timeline | null {
        this.stagger = GameSetting.isFastSpin ? HorribleHeroesGameConfig.instance.REEL_FAST_SPIN_DELAY : this._stopDelay;
        let reelController: ReelController | null = Reels.getReel(this._reelId);
        reelController?.onGameDataParsed(data);
        return this.stopReel(data, false);
    }

    /**
     * @inheritDoc
     * @param isActive
     * @param data
     */
    public abort(isActive: boolean, data: HorribleHeroesParsedGameData): Timeline | null {
        return this.stopReel(data, true);
    }

    /**
     * @inheritDoc
     * @param data
     */
    public prepare(data: HorribleHeroesParsedGameData): void {
        this.isAlreadyPlayed = false;
        this._reelId === 0 && HorribleHeroesGameModuleConfig.scatterPlusOne.prepareData(data!);
    }

    /**
     * @description To stop the reel.
     * @param data
     * @param isQuickStop
     */
    private stopReel(gameData: HorribleHeroesParsedGameData, isQuickStop: boolean): Timeline | null {
        let retVal: Timeline | null = HorribleHeroes.timelineReelsController.stopSpin(this._reelId, gameData, isQuickStop);
        retVal.add(() => (Reels.getReel(this._reelId)! as HorribleHeroesReelController).reOrderSymbols(), 0);
        retVal.add(() => {
            const inFreespin: boolean = gameData.mode.indexOf("FREESPIN") > -1;
            !this.isAlreadyPlayed && this.plusFreeSpinAnimation(retVal!, inFreespin, gameData, isQuickStop);
            this.isAlreadyPlayed = true;
        },retVal.totalDuration()+0.2);
        return retVal;
    }



    private plusFreeSpinAnimation(retVal: Timeline, doPlusOne: boolean, gameData: HorribleHeroesParsedGameData, isQuickStop: boolean): void {
        const sPos: number = gameData!.scatterPositions![this._reelId];
        if (sPos > -1) {
            if (doPlusOne) {
                if (sPos > -1) {
                    retVal.add(HorribleHeroesGameModuleConfig.scatterPlusOne.updateSpinButton(this._reelId, sPos, true, isQuickStop), 0);
                }
            }
        }
    }
}
